import { SidePathList } from "./SidePathList";

const PATHS = [
  { id: "list_account", label: "List Account", path: "/list-account" },
  { id: "chat", label: "Chat", path: "/" },
  { id: "logout", label: "Logout", path: "/login/callback" },
];

interface Props {}

export const SidePaths: React.FC<Props> = () => {
  return <SidePathList paths={PATHS} />;
};
